import React from "react";
import Delegation from "../components/governance/Delegation";
import { useLocation } from "react-router-dom";
import Stats from "../components/governance/Stats";
import Lock from "../components/governance/Lock";

const Governance = () => {
  const location = useLocation();

  const route = [
    {
      route: "/governance/delegation",
      componant: <Delegation />,
    },
    {
      route: "/governance/stats",
      componant: <Stats />,
    },
    {
      route: "/governance/lock",
      componant: <Lock />,
    },
  ];

  return (
    <div>
      {route?.map(
        (items, i) =>
          location.pathname === items.route && (
            <div key={i}>{items.componant}</div>
          )
      )}
    </div>
  );
};

export default Governance;
